import { ethers } from "ethers";
import getDecryptedRPC from "../utils/getDecryptedRPC"; // Your own logic

let provider = null;

export default function getProvider() {
  if (!provider) {
    const rpc = getDecryptedRPC();
    provider = new ethers.providers.JsonRpcProvider(rpc);
  }
  return provider;
}
